// Melinam product page helpers: delivery date checkpoints + sticky add-to-cart bar.

if (!customElements.get('mel-ship-dates')) {
  customElements.define('mel-ship-dates', class extends HTMLElement {
    connectedCallback() {
      const split = s => (s || '').split(',').map(x => x.trim());
      const days = split(this.dataset.days), months = split(this.dataset.months);
      // JS getDay(): 0 = Sunday; labels start on Monday
      const dayName = d => days[(d.getDay() + 6) % 7] || '';
      const pad = n => String(n).padStart(2, '0');
      const fmt = d => {
        const m = months[d.getMonth()] || '', dd = d.getDate();
        switch (this.dataset.format) {
          case 'day_mm_dd': return `${dayName(d)}, ${m} ${dd}`;
          case 'day_dd_mm': return `${dayName(d)}, ${dd} ${m}`;
          case 'dd_mm': return `${dd} ${m}`;
          case 'day_dd_mm_numeric': return `${dayName(d)}, ${pad(dd)}/${pad(d.getMonth() + 1)}`;
          case 'dd_mm_numeric': return `${pad(dd)}/${pad(d.getMonth() + 1)}`;
          default: return `${m} ${dd}`; // mm_dd
        }
      };
      const plus = n => { const d = new Date(); d.setDate(d.getDate() + (parseInt(n, 10) || 0)); return d; };
      this.querySelectorAll('[data-text]').forEach(el => {
        el.innerHTML = el.dataset.text
          .replace(/\[start_date\]/g, fmt(plus(el.dataset.min)))
          .replace(/\[end_date\]/g, fmt(plus(el.dataset.max)));
      });
    }
  });
}

if (!customElements.get('mel-sticky-atc')) {
  customElements.define('mel-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      const form = document.getElementById(this.dataset.form);
      const select = this.querySelector('[data-sticky-variant]');
      const price = this.querySelector('[data-sticky-price]');
      if (select && form) {
        select.addEventListener('change', () => {
          const input = form.querySelector('input[name="id"]');
          if (input) { input.value = select.value; input.dispatchEvent(new Event('change', { bubbles: true })); }
          const opt = select.selectedOptions[0];
          if (price && opt) price.textContent = opt.dataset.price;
        });
      }
      document.body.classList.add('has-mel-sticky-atc');
      if (this.classList.contains('mel-sticky-atc--after-scroll')) {
        const target = form || document.querySelector('.product-form');
        if (target) new IntersectionObserver(([e]) => {
          this.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(target);
      } else {
        this.classList.add('is-visible');
      }
    }
  });
}
